export default __webpack_public_path__ + "static/media/filebox.f4eb2b27.jpeg";